module.exports = __webpack_public_path__ + "static/avataar-f4f098468b8154b760e89ccbd4f180c9.svg";